import React, { useState, useEffect } from "react"
import logo from "../images/logo.svg"
import nav from "./navbar.module.scss"
import button from "./button.module.scss"
import { Link } from "gatsby"
import FeatherIcon from "feather-icons-react"

export default function Navbar() {
  const [scroll, setScroll] = useState(false)

  const [collapse, setCollapse] = useState(false)

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck)
      }
    })
  })

  const handleCollapse = () => {
    setCollapse(!collapse)
  }

  const navScroll = scroll ? nav.scrolled : ""
  const navCollapse = collapse ? nav.collapsed : ""

  return (
    <nav className={navScroll}>
      <div className={nav.wrapper}>
        <Link to="/">
          <img className={nav.logo} src={logo} alt="logo" />
        </Link>
        <div className={nav.burger} onClick={handleCollapse}>
          <FeatherIcon icon="menu" />
        </div>
        <ul className={` ${nav.linklist} ${navCollapse}`}>
          <li>
            <Link className={nav.link} activeClassName={nav.active} to="/">
              Frontpage
            </Link>
          </li>
          <li>
            <Link className={nav.link} activeClassName={nav.active} to="/pricing/">
              Pricing
            </Link>
          </li>
          <li>
            <Link className={nav.link} activeClassName={nav.active} to="/news/">
              News
            </Link>
          </li>
          <li>
            <Link className={nav.link} activeClassName={nav.active} to="/contact/">
              Contact
            </Link>
          </li>
        </ul>

        <div className={nav.cta}>
          <Link
            className={`${button.btn} ${button.cta}`}
            to="/404/"
          >
            Get App
          </Link>
          {/* <select id="lang">
            <option value="en">EN</option>
            <option value="da">DA</option>
          </select> */}
        </div>
      </div>
    </nav>
  )
}
